type HttpMethod = "GET" | "POST";

interface ApiRequestOptions {
  method?: HttpMethod;
  token?: string;
  body?: unknown;
  query?: Record<string, string | number | boolean | undefined | null>;
}

let onAuthError: (() => void) | null = null;

export function setAuthErrorHandler(handler: () => void) {
  onAuthError = handler;
}

const rawBaseUrl =
  (import.meta.env.VITE_API_BASE_URL as string | undefined) ?? "/api";
const API_BASE_URL = rawBaseUrl.replace(/\/$/, "");

function buildUrl(action: string, query?: ApiRequestOptions["query"]) {
  const params = new URLSearchParams();
  params.set("action", action);

  if (query) {
    Object.entries(query).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        params.set(key, String(value));
      }
    });
  }

  return `${API_BASE_URL}/index.php?${params.toString()}`;
}

export async function apiRequest<T>(
  action: string,
  options: ApiRequestOptions = {},
): Promise<T> {
  const { method = "GET", token, body, query } = options;

  const response = await fetch(buildUrl(action, query), {
    method,
    headers: {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body:
      method === "POST" && body !== undefined
        ? JSON.stringify(body)
        : undefined,
  });

  const responseText = await response.text();
  let data: any = {};
  if (responseText) {
    try {
      data = JSON.parse(responseText);
    } catch {
      data = {};
    }
  }

  if (!response.ok) {
    const message =
      typeof data?.error === "string"
        ? data.error
        : responseText.trim() !== ""
          ? `Errore API (${response.status}): ${responseText.slice(0, 180)}`
          : `Errore API (${response.status})`;
    if (message.includes("Token")) {
      onAuthError?.();
    }
    throw new Error(message);
  }

  return data as T;
}
